import { Drawer, DrawerProps } from "antd";
import * as React from "react";
import { classNames } from "src/common/classNames";

import * as styles from "./MdmDrawer.module.less";

const widths = {
  wide: "85%",
  form: "780px",
};

export type MdmDrawerProps = Omit<DrawerProps, "width"> & {
  wide?: boolean;
};

/**
 * Унифицированный Drawer MDM (MDM2-871).
 */
export const MdmDrawer: React.FC<MdmDrawerProps> = ({
  wide = false,
  className,
  closable = true,
  placement = "right",
  height = "100%",
  ...rest
}) => (
  <Drawer
    {...rest}
    placement={placement}
    width={wide ? widths.wide : widths.form}
    height={height}
    closable={closable}
    mask
    maskClosable={false}
    className={classNames([styles.drawer, className])}
  />
);
